var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dummy-library-item",class:[_vm.publication.type.toLowerCase()]},[_c('div',{staticClass:"book-image-box"},[_c('v-img',{staticClass:"dummy-cover",attrs:{"lazy-src":_vm.bookCoverPath,"src":_vm.bookCoverPath,"alt":_vm.alternativeText}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }